import TableWithCheckboxes from "../../../../../ui/tables/table-with-checkboxes/TableWithCheckboxes";
import {headCells} from "./EsitoCambioFormatoTableHelper";
import {IconButton, TableCell, TableRow, Tooltip} from "@material-ui/core";
import EmptyRow from "../../../../../ui/tables/rows/empty-row/EmptyRow";
import Checkbox from "@material-ui/core/Checkbox";
import {returnSelectedRows} from "../../../../../../shared/utils/tableUtils";
import PropTypes from "prop-types";
import {useSelector} from "react-redux";
import HelpIcon from "@material-ui/icons/Help";
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import { formatMissingData } from "shared/utils/formatDataUtils";

const EsitoCambioFormatoTable = (props) => {
     const tableData = useSelector(state => state.eSimReducer.esitoCambioFormatoTableData.data);
    const totalTableData = useSelector(state => state.eSimReducer.esitoCambioFormatoTableData.total);
    const tableLoading = useSelector(state => state.eSimReducer.esitoCambioFormatoTableData.loading);

    const handleCheckboxClick = (e, row) => {
        e.stopPropagation()
        const selectedIndex = props.selected.findIndex(i => i.id === row.id);
        props.setSelected(returnSelectedRows(props.selected, row, selectedIndex));
    }

    const isSelected = (id) => props.selected.some(d => d.id === id);

    const tableRows = (
        tableData.length !== 0 ?
            tableData.map((row, idx) => {
                const isItemSelected = isSelected(row.id);
                const labelId = `esito-cambio-formato-table-checkbox-${idx}`;

                return (
                    <TableRow
                        role="checkbox"
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                        key={row.id}
                        selected={isItemSelected}
                    >
                        <TableCell padding="checkbox">
                            <Checkbox
                                checked={isItemSelected}
                                onClick={(e) => handleCheckboxClick(e, row)}
                                inputProps={{'aria-labelledby': labelId}}
                            />
                        </TableCell>
                        <TableCell align="left">
                            {row.idLotto}{row.idLottoCambioFormatoPopupText ?
                            <Tooltip title={formatMissingData(row.idLottoCambioFormatoPopupText)} arrow style={{marginLeft:"3px"}}>
                                <IconButton size={"small"}  color={"secondary"}>
                                   <MailOutlineIcon fontSize="small"/>
                                </IconButton>
                            </Tooltip>
                            : null}</TableCell>
                        <TableCell align="left">{row.numeroDiTelefono}</TableCell>
                        <TableCell align="left">{row.nuovoSeriale}</TableCell>
                        <TableCell align="left">{row.dataInvioRichiesta}</TableCell>
                        <TableCell align="left">{row.esitoCambioFormato}</TableCell>
                        <TableCell align="left" >{row.causaleKo}{row.causaleKoCambioFormatoPopupText ?
                            <Tooltip title={formatMissingData(row.causaleKoCambioFormatoPopupText)} arrow >
                                <IconButton size={"small"}  color={"secondary"}>
                                   <HelpIcon fontSize="small"/>
                                </IconButton>
                            </Tooltip>
                            : null}</TableCell>

                    </TableRow>
                )
            }) : <EmptyRow text="dato" colSpan={headCells.length + 2}/>
    )

    return (
        <TableWithCheckboxes
            selected={props.selected}
            setSelected={props.setSelected}
            page={props.page}
            rowsPerPage={props.rowsPerPage}
            fetchData={props.handlePaginationChange}
            count={totalTableData}
            loading={tableLoading}
            tableRows={tableRows}
            rows={tableData}
            headCells={headCells}
            selectAllRows={props.areAllSelected}
            setSelectAllRows={props.setAreAllSelected}
        />
    )
};

EsitoCambioFormatoTable.propTypes = {
    selected: PropTypes.array.isRequired,
    setSelected: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
    handlePaginationChange: PropTypes.func.isRequired,
    areAllSelected: PropTypes.bool.isRequired,
    setAreAllSelected: PropTypes.func.isRequired
}

export default EsitoCambioFormatoTable;
